module.exports = __webpack_public_path__ + "img/none.d8c24b19.png";